import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ZoomAndPanService } from "../services/zoom-and-pan.service";

@Component({
  selector: "dua-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent implements OnInit {
  constructor(
    private router: Router,
    private zoomAndPanService: ZoomAndPanService
  ) {}

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  zoomLineMap(sign: number) {
    this.zoomAndPanService.triggerManualZoom(sign, "line-map");
  }
}
